// extracted by mini-css-extract-plugin
module.exports = {"teamMemberStyle":"styles_teamMemberStyle__3GKF1","projectMemberStyle":"styles_projectMemberStyle__2gA0A","dropdownClassName":"styles_dropdownClassName__2y4yL"};